import { authClient, API } from "../../utils/index";
import { uploadSingleFile } from "../files";
import {
  normalizeArticleBeforeSend,
  extractArticleFiles,
} from "../../utils/helpers";

// ------- Lectura / borrado -------

export const getArticles = () => {
  return authClient().get(`${API}/article`);
};

export const getArticleById = (id) => {
  return authClient().get(`${API}/article/${id}`);
};

export const getArticlesByRegatta = (id) => {
  return authClient().get(`${API}/article/regatta/${id}`);
};

export const deleteArticle = (id) => {
  return authClient().delete(`${API}/article/${id}`);
};

export const getArticlesBySailor = (sailorId) => {
  return authClient().get(`${API}/article/sailor/${sailorId}`);
};

// ------- Escritura (create / update) -------

/**
 * Sube un archivo y devuelve su URL (o null).
 * Se deja en este nivel (API) para mantener la capa de IO aquí.
 */
async function uploadOptionalFile(file, folder = "articles") {
  if (!file) return null;
  const res = await uploadSingleFile(file, folder);
  return res?.data?.fileURL || null;
}

/**
 * Create article
 * Firmas soportadas (compatibles):
 *  - postArticle(article, imageFile)
 *  - postArticle(article, { image?: File, cover?: File })
 */
export const postArticle = async (article, filesArg) => {
  const payload = normalizeArticleBeforeSend({ ...article });
  const { imageFile, coverFile } = extractArticleFiles(filesArg);

  // Subidas previas
  if (imageFile) {
    const url = await uploadOptionalFile(imageFile, "articles");
    if (url) payload.image = url;
  }

  if (coverFile) {
    const url = await uploadOptionalFile(coverFile, "articles"); // o "articles/covers"
    payload.cover = payload.cover || {};
    if (url) payload.cover.url = url;
  }

  return authClient().post(`${API}/article`, payload);
};

/**
 * Update article
 * Firmas soportadas (compatibles):
 *  - updateArticle(id, article, imageFile)
 *  - updateArticle(id, article, { image?: File, cover?: File })
 */
export const updateArticle = async (id, article, filesArg) => {
  const payload = normalizeArticleBeforeSend({ ...article });
  const { imageFile, coverFile } = extractArticleFiles(filesArg);

  if (imageFile) {
    const url = await uploadOptionalFile(imageFile, "articles");
    if (url) payload.image = url;
  }

  if (coverFile) {
    const url = await uploadOptionalFile(coverFile, "articles");
    payload.cover = payload.cover || {};
    if (url) payload.cover.url = url;
  }

  return authClient().put(`${API}/article/${id}`, payload);
};
